<template>
  <div>
    <template v-if="this.data != null">
      <v-card elevation="10">
        <v-card-title class="headline">
          {{ $t("events.header") }}
          <v-spacer></v-spacer>
          <v-text-field v-model="search" :label="$t('events.search')" single-line hide-details></v-text-field>
          <!-- <v-text-field v-model="search" :label="$t('events.search')" single-line hide-details></v-text-field> -->
        </v-card-title>
        <v-data-table :headers="headers" :items="data" :locale="`${$i18n.locale}`" calculate-widths loading="true" :sort-desc="true" :items-per-page="this.itemsPerPage" :search="search" :height="height">
          <template v-slot:[`item.devName`]="{ item }">
            <v-chip outlined :color="getDeviceColor(item.devName)" dark>
              <b>{{ item.devName }}</b>
            </v-chip>
          </template>

          <template v-slot:[`item.type`]="{ item }">
            <v-chip outlined :color="getTypeColor(item.type)" dark>
              <b>{{ item.type }}</b>
            </v-chip>
          </template>

          <template v-slot:[`item.unitName`]="{ item }">
            <v-chip outlined :color="getUnitColor(item.unitName)" dark>
              <b>{{ item.unitName }}</b>
            </v-chip>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template v-else>
      <LoadingData />
    </template>

    <template v-if="dashboard !== true">
      <UpgradeCore />
    </template>
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";
import LoadingData from "../../components/LoadingData.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "Events",
  components: {
    LoadingData,
    UpgradeCore,
  },
  props: {
    itemsPerPage: {},
    height: {},
    dashboard: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  /* props: ["itemsPerPage", "height", "dashboard"], */
  data() {
    return {
      timer: null,

      headers: [
        {
          text: this.$i18n.t("events.dateTime"),
          value: "dateTime",
          width: "1%",
        },
        {
          text: this.$i18n.t("events.unitName"),
          value: "unitName",
          width: "1%",
        },
        {
          text: this.$i18n.t("events.type.name"),
          value: "type",
          width: "1%",
        },
        {
          text: this.$i18n.t("events.device"),
          value: "devName",
          width: "1%",
        },
        {
          text: this.$i18n.t("events.variable"),
          value: "varDesc",
          width: "1%",
        },
        {
          text: this.$i18n.t("events.value"),
          value: "valDesc",
          width: "1%",
        },
      ],
      data: [],

      search: "",
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.pollData();
  },
  methods: {
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("events"), null, null, "GET")
        .then((data) => {
          this.data = data.events;
          this.processData();
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    processData() {
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].dateTime = this.data[i].dateTime.substr(0, 10) + " " + this.data[i].dateTime.substr(11, 8);

        this.data[i].type = this.data[i].type === "I" ? "Info" : this.data[i].type === "W" ? "Warning" : this.data[i].type === "E" ? "Error" : this.data[i].type === "F" ? "Fault" : this.data[i].type === "N" ? "Note" : "";

        if (this.data[i].varDesc === "" || this.data[i].varDesc === " ") {
          this.data[i].varDesc = this.data[i].variable;
        }
        if (this.data[i].valDesc === "" || this.data[i].valDesc === " ") {
          this.data[i].valDesc = this.data[i].value;
        }
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 10000);
    },
    getUnitColor(data) {
      switch (data) {
        case "MPPT-1":
          return "yellow darken-2";
        case "MPPT-2":
          return "amber darken-2";
        case "MPPT-3":
          return "orange darken-2";
        case "MPPT-4":
          return "deep-orange darken-2";
        case "DAB-1":
          return "light-green darken-1";
        case "DAB-2":
          return "light-green darken-2";
        case "DAB-3":
          return "light-green darken-3";
        case "DAB-4":
          return "light-green darken-4";
        case "INVERTER":
          return "blue-grey";
        case "ECCCU":
          return "teal";
        case "DBMS":
          return "light-green";
        case "ELMETER-1":
          return "purple";
        default:
          return "white";
      }
    },
    getTypeColor(data) {
      switch (data) {
        case "Info":
          return "blue darken-2";
        case "Warning":
          return "orange darken-2";
        case "Error":
          return "red darken-2";
        case "Fault":
          return "brown darken-2";
        case "Note":
          return "cyan darken-2";
        default:
          return "white";
      }
    },
    getDeviceColor(data) {
      if (data.search("Inverter") !== -1) {
        return "blue-grey";
      } else if (data.search("BCU") !== -1) {
        return "green darken-2";
      } else if (data.search("MPPT") !== -1) {
        return "yellow darken-2";
      } else if (data.search("DAB") !== -1) {
        return "light-green";
      } else if (data.search("ECCCU") !== -1) {
        return "grey";
      } else {
        return "white";
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.v-card:not(.on-hover) {
  opacity: 1;
}
</style>
